import axios from "axios";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom"; // si tu es dans un composant React



import accessToken from "../jwt-token-access/accessToken";

//pass new generated access token here
const token = accessToken;

//apply base url for axios
const API_PURCHASES_URL = process.env.REACT_APP_ACADEMIC_MANAGEMENT_SERVICE_URL;

const axiosApi = axios.create({
  baseURL: API_PURCHASES_URL,
   headers: { 
    'Content-Type': 'application/json',
    'Accept': 'application/json'

   }
});

//console.log("TOKEN: ", token);

axiosApi.defaults.headers.common["Authorization"] = token;
//axios.defaults.baseURL = API_PURCHASES_URL;


/*
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

*/

// Intercepteur pour gérer erreurs
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;

      if (status === 401) {
        // Token invalide ou expiré
        toast.error("Votre session a expiré, veuillez vous reconnecter.");
        // Redirection vers login
        window.location.href = "/login"; // redirection simple
      } else {
        // Autres erreurs
        toast.error(error.response.data?.message || "Une erreur est survenue");
      }
    } else {
      toast.error("Impossible de contacter le serveur");
    }
    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {

  
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
